module.exports = __webpack_public_path__ + "static/media/cases.ffebfdfc.svg";